"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var _ = require('lodash');

var compose = require('../hoc/compose');

var displayNames = require('./displayNames');

var DropDownOption = require('./dropDownOption');

var TooltipOnEllipsis = require('./tooltipOnEllipsis');

var DropDownCheckboxContainer = require('./dropDownCheckboxContainer');

var DropDownListItemOption = function DropDownListItemOption(props) {
  return /*#__PURE__*/React.createElement(DropDownOption, _.assign({}, {
    className: 'dropdown-list-item-option',
    forceChildren: true
  }, _.omit(props, 'children')), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-list-item-option-preview"
  }, props.checkbox && /*#__PURE__*/React.createElement(DropDownCheckboxContainer, {
    selected: props.selected,
    disabled: props.disabled,
    className: "dropdown-list-item-option-checkbox"
  }), props.prefix && !props.isSelectedElement && /*#__PURE__*/React.createElement("div", {
    className: "dropdown-list-item-option-prefix"
  }, props.prefix), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-list-item-option-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-list-item-option-detailed-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-list-item-option-title"
  }, /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
    marginTop: -10,
    closeOnMouseClick: true
  }, props.label)), props.subtitle && !props.isSelectedElement && /*#__PURE__*/React.createElement("div", {
    className: "dropdown-list-item-option-subtitle"
  }, /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
    marginTop: -10,
    closeOnMouseClick: true
  }, props.subtitle))))));
};

DropDownListItemOption.displayName = displayNames.DROP_DOWN_LIST_ITEM_OPTION;
DropDownListItemOption.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  checkbox: PropTypes.bool,
  subtitle: PropTypes.node,
  prefix: PropTypes.node
};
module.exports = compose(DropDownListItemOption);